import { sizeProp } from "../../propTypes";


export const CloudCrossIcon = ({ size = 24}) => {
    return (
        <svg width={size} height={size} viewBox={`0 0 24 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4418_9160)">
                <path d="M16.61 19.9999C17.95 20.0099 19.24 19.5099 20.23 18.6099C23.5 15.7499 21.75 10.0099 17.44 9.46995C15.9 0.129949 2.42998 3.66995 5.61998 12.5599" stroke="colorContent" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.27999 12.9698C6.74999 12.6998 6.15999 12.5598 5.56999 12.5698C0.909986 12.8998 0.919986 19.6798 5.56999 20.0098" stroke="colorContent" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.8199 9.89047C16.3399 9.63047 16.8999 9.49047 17.4799 9.48047" stroke="colorContent" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.3901 18.5898L9.56006 21.4098" stroke="colorContent" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.3901 21.4098L9.56006 18.5898" stroke="colorContent" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4418_9160">
                <   rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

CloudCrossIcon.propTypes = sizeProp
